import React from 'react';
import PropTypes from 'prop-types';
import BlogPosts from 'containers/BlogPosts';

/**
 *
 * Show posts that is relating to a a category ID
 *
 * @param {object} props
 * @property {string} props.category A valid WP Category ID
 * @property {number} props.limit The number of posts to show
 * @returns
 */
const RelatedBlogPosts = ({ limit = 4, isPodcast, posts }) => {
  // Prevent rendering a long list of blog posts
  const limitedRelatedContent = posts.splice(0, limit);
  return (
    <BlogPosts
      inversePostCards={false} // Use the whitebackground blog posts cards
      title={<>Related</>}
      description={<></>}
      isPodcasts={isPodcast}
      blogPosts={limitedRelatedContent}
    />
  );
};

RelatedBlogPosts.propTypes = {
  isPodcast: PropTypes.bool,
  categoryId: PropTypes.string,
  limit: PropTypes.number,
  posts: PropTypes.array,
};

export default RelatedBlogPosts;
